export default __webpack_public_path__ + "static/media/ic-crops-garlic.0a038409.svg";